import { render } from "./Scatter.vue?vue&type=template&id=3ed02cd2&scoped=true"
import script from "./Scatter.vue?vue&type=script&lang=js"
export * from "./Scatter.vue?vue&type=script&lang=js"

import "./Scatter.vue?vue&type=style&index=0&id=3ed02cd2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ed02cd2"

export default script